import { useState } from "react";
import { AccountTypeSelection } from "./components/AccountTypeSelection";
import { RegisterOrganization } from "./RegisterOrganization";
import { ContentBoxTitle, LargeContentBox } from "@/components/common";
import { RegisterCPF } from "./RegisterCPF";

export function Register() {
  const type = localStorage.getItem("operation");
  const [accountType, setAccountType] = useState<"cpf" | "cnpj" | undefined>(
    type === "renewPlan" ? "cnpj" : undefined
  );

  const handleAccountTypeChange = (type: "cpf" | "cnpj") => {
    setAccountType(type);
  };

  const handleBackToSelection = () => {
    setAccountType(undefined);
  };

  return (
    <>
      {accountType === undefined && (
        <LargeContentBox>
          <AccountTypeSelection onSelectType={handleAccountTypeChange} />
        </LargeContentBox>
      )}
      {accountType === "cpf" && (
        <RegisterCPF onBackToSelection={handleBackToSelection} />
      )}
      {accountType === "cnpj" && (
        <RegisterOrganization onBackToSelection={handleBackToSelection} />
      )}
    </>
  );
}
